import { useLayoutEffect, useState } from 'react';
import { string } from 'prop-types';
import useWithPositionData from 'library/hooks/use-with-position-data';
import getPositioning  from 'library/util/get-positioning';

const useOnboardingTip = ({ target, verticalPosition, horizontalPosition }) => {
  const [tipActive, setTipActive] = useState(false);
  const [positionData, setPositionData] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const [node, setNode] = useState(null);

  const { position } = useWithPositionData({node});

  useLayoutEffect(() => {
    let targetNode = document.getElementById(target);
    if (targetNode) {
      setNode(targetNode);
      setTipActive(true);
    }
  }, [target]);

  useLayoutEffect(() => {
    if (position && tipActive) {
      setPositionData(
        getPositioning(position, verticalPosition, horizontalPosition)
      );
    }
  }, [position]);

  const handleClose = () => {
    setTipActive(false);
    setTimeout(() => {
      setDismissed(true);
      setNode(null);
    }, 600);
  };

  return {
    tipActive,
    positionData,
    dismissed,
    handleClose
  };
};

useOnboardingTip.propTypes = {
  target: string,
  verticalPosition: string,
  horizontalPosition: string,
};

export default useOnboardingTip;